export default __webpack_public_path__ + "static/media/systemowe4.1c79b4bb.jpg";